import { ReactComponent as Facebook } from '@pflegia/ui/icons/icon-social-media-facebook-new.svg';
import { isDesktop } from '@pflegia/util/functions/device-detection';

import Button from './Button.component';

interface ShareOnFacebookButtonProps {
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

const DELAY_TIMEOUT = 1000;

const ShareOnFacebookButton: React.FC<ShareOnFacebookButtonProps> = ({ Icon = Facebook }) => {
  const openFacebookShare = () => {
    const encodedLocation = encodeURIComponent(window.location.href);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedLocation}`;
    const appId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID; // Adding appId for improved Messenger deep linking
    const messengerUrl = `fb-messenger://share?link=${encodedLocation}&app_id=${appId}`;

    if (isDesktop()) {
      window.open(facebookUrl, '_blank');
      return;
    }
    window.location.href = messengerUrl;
    // fallback if Messenger isn't installed
    setTimeout(() => {
      window.location.href = facebookUrl;
    }, DELAY_TIMEOUT);
  };

  return (
    <Button
      data-testid='facebook-button'
      label='Facebook'
      className='w-full bg-blue-600 sm:w-auto'
      icon={<Icon />}
      onClick={openFacebookShare}
    />
  );
};

export default ShareOnFacebookButton;
